import { IntegrationDto } from "@api";
import { createSelector, DefaultProjectorFn, MemoizedSelector } from "@ngrx/store";
import { RootState } from "..";
import { IntegrationState } from "./state";

const selectFeature = (state: RootState): IntegrationState => state.integration;

export const selectLoading = createSelector(selectFeature, state => state.loading);

export const selectIntegrations = createSelector(selectFeature, state => Object.values(state.integrations));

export const selectIntegration = (
  type: IntegrationDto.TypeEnum,
): MemoizedSelector<RootState, IntegrationDto, DefaultProjectorFn<IntegrationDto>> =>
  createSelector(selectFeature, state => Object.values(state.integrations).find(integration => integration.type === type));
